// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function unionByPreferringLast(comparator, overlapOpt, arr1, arr2) {
  let overlap = overlapOpt !== undefined ? overlapOpt : 3;
  let result = arr2.slice();
  let arr1LastIdx = arr1.length - 1 | 0;
  let stopCheck = overlap === 0 ? 0 : arr1LastIdx - overlap | 0;
  for (let i = arr1LastIdx; i >= 0; --i) {
    let a1 = Stdlib_Option.getOrThrow(arr1[i], undefined);
    let duplicate = i > stopCheck && arr2.some(i => comparator(a1, i));
    if (!duplicate) {
      result.unshift(a1);
    }
  }
  return result;
}

export {
  unionByPreferringLast,
}
/* No side effect */
